export const ValidationMessage = ({ isError, isTouch, message }) => {
  return isError && isTouch && <span className="text-[#ab0505] text-[15px]">{message}</span>
}